/** How MIME types are shown. Not an allowlist — an unmapped type still renders and uploads. */
const MIME_PRESENTATION: Record<string, { extension: string; label: string }> = {
  'application/pdf': { extension: '.pdf', label: 'PDF' },
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
    extension: '.docx', label: 'DOCX',
  },
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
    extension: '.xlsx', label: 'XLSX',
  },
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': {
    extension: '.pptx', label: 'PPTX',
  },
  'application/zip': { extension: '.zip', label: 'ZIP' },
  'application/x-zip-compressed': { extension: '.zip', label: 'ZIP' },
  'text/plain': { extension: '.txt', label: 'TXT' },
  'text/csv': { extension: '.csv', label: 'CSV' },
  'application/vnd.ms-excel.sheet.macroenabled.12': { extension: '.xlsm', label: 'XLSM' },
};

const fallbackLabel = (mime: string): string =>
  (mime.split('/').pop() ?? mime).toUpperCase();

export const extensionsFor = (mimeTypes: readonly string[]): string[] =>
  Array.from(new Set(
    mimeTypes
      .map((mime) => MIME_PRESENTATION[mime]?.extension)
      .filter((extension): extension is string => Boolean(extension)),
  ));

export const labelsFor = (mimeTypes: readonly string[]): string[] =>
  Array.from(new Set(
    mimeTypes.map((mime) => MIME_PRESENTATION[mime]?.label ?? fallbackLabel(mime)),
  ));
